<app-head-nav [isParentLink]="!isMainProfile" [hasBranshes]="false" [hasRestaurant]="false"
  [currentView]="lang == 'en' ? restaurantProfile?.title_EN : restaurantProfile?.title_AR">
</app-head-nav>

<div *ngIf='dataLoading' class="dataLoading py-5">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div class="form-page">
  <div class="form-content form-content-full">
    <ng-container *ngIf='!dataLoading && restaurantProfile'>

      <div class="row mb-3">
        <div class="col-12" [ngClass]="{'col-lg-6': restaurantProfile.restaurantProfileLicense}">
          <div class="card py-3 h-100">
            <div class="card-head">
              <div class="title">{{'restaurant.Enable Clock-in/out' | translate}}</div>

              <div class="d-flex align-items-center">
                <div class="mr-3" *ngIf="attandanceFeatureLoader">
                  <mat-spinner diameter="20"></mat-spinner>
                </div>
                <div>
                  <mat-slide-toggle [(ngModel)]="restaurantProfile.attandanceFeature"
                    [disabled]="attandanceFeatureLoader" (ngModelChange)="changeAttendance()"></mat-slide-toggle>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12" *ngIf="restaurantProfile.restaurantProfileLicense">
          <div class="card h-100">
            <div class="card-head">
              <div class="title">{{'profile.License' | translate}}
                <div>
                  <span class="status-badge red font-12 py-0 px-2" *ngIf="isLicenseExpired">{{'wastedFood.Expired' | translate}}</span>
                </div>
              </div>

              <div class="flex-container bordered d-flex mb-0">
                <div class="block">
                  <div class="row">
                    <div class="col-12">
                      <p class="font-16 fontRegular grey-color">{{'availabilty.Start Date' | translate}}</p>
                    </div>
                    <div class="col-12">
                      <p class="font-16 fontMedium mt-2">{{restaurantProfile.restaurantProfileLicense.startDate | date: 'dd MMM, yyyy'}}</p>
                    </div>
                  </div>
                </div>
                <div class="block">
                  <div class="row">
                    <div class="col-12">
                      <p class="font-16 fontRegular grey-color">{{'profile.Expiry Date' | translate}}</p>
                    </div>
                    <div class="col-12">
                      <p class="font-16 fontMedium mt-2">{{restaurantProfile.restaurantProfileLicense.endDate | date: 'dd MMM, yyyy'}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <app-publish-restaurant *ngIf="!restaurantProfile.isPublish" [restaurantProfile]="restaurantProfile"
        [restaurantId]="restaurantId"></app-publish-restaurant>
      <app-head-details [restaurantProfile]="restaurantProfile"></app-head-details>

      <ng-container *ngIf="!isMainProfile">

        <ul class="nav nav-tabs" id="tabs" [hidden]="dataLoading" (mousedown)="startDragging($event, false)"
          (mouseup)="stopDragging($event, false)" (mouseleave)="stopDragging($event, false)"
          (mousemove)="moveEvent($event)">
          <li class="nav-item" *ngFor="let item of tabs; index as index">
            <a class="nav-link font-16 fontMedium" [class.active]="activeIndex == index"
              (click)="navigateToSection($event, index)">{{item.name}}</a>
          </li>
        </ul>

      </ng-container>

      <app-numbers *ngIf="!isMainProfile" [restaurantProfile]="restaurantProfile"></app-numbers>

      <app-basic-info id="tab-0" [restaurantProfile]="restaurantProfile"></app-basic-info>
      <ng-container *ngIf="!isMainProfile && restaurantProfile.canShowShortCut">
      <app-navigation *ngIf="restaurantProfile.canViewConfigSection"></app-navigation>

      <app-zatca-detials *ngIf="restaurantProfile.canViewZatcaSection" [restaurantProfile]="restaurantProfile"></app-zatca-detials>

      </ng-container>
      <div id="tab-1" class="placeholder">
        <app-gallery [restaurantId]="restaurantId" *inView></app-gallery>
      </div>
      <div id="tab-2" class="placeholder">
        <app-amenities [restaurantId]="restaurantId" *inView id="tab-2"></app-amenities>
      </div>

      <ng-container *ngIf="!isMainProfile">
        <!-- <div id="tab-5" class="placeholder">
          <app-guest-reviews [restaurantId]="restaurantId" *inView id="tab-5"></app-guest-reviews>
        </div> -->
        <!-- <div id="tab-5" class="placeholder">
          <app-guest-reviews [restaurantId]="restaurantId" *inView id="tab-5"></app-guest-reviews>
        </div>
        <div id="tab-6" class="placeholder">
          <app-events [restaurantId]="restaurantId" *inView id="tab-6"></app-events>
        </div>
        <div id="tab-7" class="placeholder">
          <app-guest-announcement [restaurantId]="restaurantId" *inView id="tab-7"></app-guest-announcement>
        </div> -->
        <div id="tab-3" class="placeholder">
          <app-payment-methods [restaurantId]="restaurantId" *inView id="tab-6"></app-payment-methods>
        </div>
        <div id="tab-4" class="placeholder">
          <app-cancellation *inView id="tab-6" [canViewCancellationPolicy]="restaurantProfile.canViewCancellationPolicy"
            [canAddCancellationPolicy]="restaurantProfile.canAddCancellationPolicy"
            [canEditCancellationPolicy]="restaurantProfile.canEditCancellationPolicy"
            [canDeleteCancellationPolicy]="restaurantProfile.canDeleteCancellationPolicy"></app-cancellation>
        </div>
        <div id="tab-5" class="placeholder">
          <app-reservation *inView id="tab-7"></app-reservation>
        </div>
      </ng-container>

    </ng-container>
  </div>
</div>
